// extracted by mini-css-extract-plugin
export default {"card":"sM","cardrow":"tM","cardcentered":"uM","details":"vM","imgwrapper":"wM","img":"xM","category":"yM","name":"zM","copy":"AM","detailsbtn":"BM","remove":"CM","price":"EM","netPrice":"FM","regularPrice":"GM","label":"HM"};
    if(module.hot) {
      // 1714654894077
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  